<template>
  <div class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="dark">
            <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          accordion="my-accordion"
          role="tabpanel"
          visible
        >
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان فارسی:</strong>
                  {{ proposal.faSubject }}
                </li>

                <li>
                  <strong class="c-purple"
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟</strong
                  >
                  <b-form-radio-group
                    v-model="proposal.initialIsSupported"
                    disabled
                  >
                    <b-form-radio :value="true">بله</b-form-radio>
                    <b-form-radio :value="false">خیر</b-form-radio>
                  </b-form-radio-group>
                </li>

                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">حمایت ها: </strong
                  >{{
                    options.filter(
                      (x) => x.value == proposal.initialSupportedType
                    )[0].text
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                >
                  <strong class="c-purple">عنوان حمایت دریافتی: </strong
                  >{{ proposal.initialOtherSupport }}
                </li>
                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">توضیحات حمایت دریافتی: </strong
                  >{{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="dark">
            <h5 class="mb-0">اطلاعات اصلی طرح</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ul>
              <li>
                <strong class="c-purple">عنوان به زبان فارسی: </strong>
                {{ proposal.faSubject }}
              </li>
              <li>
                <strong class="c-purple">عنوان به زبان انگلیسی: </strong>
                {{ proposal.enSubject }}
              </li>
              <li>
                <strong class="c-purple">دانشگاه محل اجرای طرح: </strong>
                {{
                  proposal.universityId
                    ? universities.filter(
                        (x) => x.id == proposal.universityId
                      )[0]
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0].text
                      : ""
                    : ""
                }}
              </li>
              <li v-if="proposal.universityId == notUniversity">
                <strong class="c-purple"> نام دانشگاه: </strong>
                {{ proposal.otherUniversity }}
              </li>
              <li>
                <strong class="c-purple">محور طرح: </strong>
                <span
                  v-if="proposal.mehvarId != notMehvar"
                  class="grey--text text--darken-4"
                >
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </span>
                <span v-else>سایر محورها</span>
              </li>
              <li v-if="proposal.mehvarId == notMehvar">
                <strong class="c-purple"> نام محور: </strong>
                {{ proposal.otherMehvars }}
              </li>
              <li class="mb-4">
                <strong class="c-purple">ماهیت طرح:</strong>
                <b-form-group disabled>
                  <b-form-checkbox v-model="proposal.typeStudy"
                    >مطالعاتی</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.typeSystemicDevelopmental"
                    >سیستمی و توسعه‌ای</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.typePractical"
                    >کاربردی</b-form-checkbox
                  >
                </b-form-group>
              </li>
              <li class="mb-4">
                <strong class="c-purple">حوزه طرح:</strong>
                <b-form-group disabled>
                  <b-form-checkbox v-model="proposal.zoneMedicine"
                    >پزشکی</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.zoneAgriculture"
                    >کشاورزی</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.zoneEnvironment"
                    >محیط زیست</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.zoneIndustrial"
                    >صنعتی</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.zoneBioComputing"
                    >رایانش زیستی</b-form-checkbox
                  >
                  <b-form-checkbox v-model="proposal.zoneOther"
                    >سایر</b-form-checkbox
                  >
                </b-form-group>
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <!-- NOTE (b-accordion2) previous -->
          <b-button block v-b-toggle.accordion-3 variant="light">
            <h5 class="mb-0">اطلاعات مجری طرح</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ul>
              <li>
                <strong class="c-purple">نام: </strong>

                {{ proposal.researcherName }}
              </li>
              <li>
                <strong class="c-purple">نام خانوادگی: </strong>

                {{ proposal.researcherLastName }}
              </li>
              <li>
                <strong class="c-purple">کدملی: </strong>

                {{ proposal.researcherNatCode }}
              </li>
              <li>
                <strong class="c-purple">تلفن همراه: </strong>

                {{ proposal.researcherMobile }}
              </li>
              <!-- <li>تلفن منزل: {{executor.homePhone}}</li> -->
              <!-- <li>تلفن محل کار: {{executor.officePhone}}</li> -->
              <li>
                <strong class="c-purple">دورنگار: </strong>

                {{ proposal.researcherFax }}
              </li>
              <li>
                <strong class="c-purple"> پست الکترونیکی: </strong>

                {{ proposal.researcherEmail }}
              </li>
              <li>
                <strong class="c-purple">استان: </strong>

                {{ proposal.researcherState }}
              </li>
              <li>
                <strong class="c-purple">شهر: </strong>

                {{ proposal.researcherCity }}
              </li>
              <li>
                <strong class="c-purple">دانشگاه محل تحصیل: </strong>

                {{
                  proposal.researcherUniversityId
                    ? universities.filter(
                        (x) => x.id == proposal.researcherUniversityId
                      )[0]
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0].text
                      : ""
                    : ""
                }}
              </li>
              <li v-if="proposal.researcherUniversityId == notUniversity">
                <strong class="c-purple"> نام دانشگاه: </strong>

                {{ proposal.researcherUniversityOther }}
              </li>

              <!-- <li>آدرس منزل: {{executor.address}}</li> -->
              <!-- <li>آدرس محل کار: {{executor.officeAddress}}</li> -->
              <li>
                <strong class="c-purple"
                  >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:
                </strong>

                {{
                  proposal.researcherUniversityJobId
                    ? universities.filter(
                        (x) => x.id == proposal.researcherUniversityJobId
                      )[0]
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityJobId
                        )[0].text
                      : ""
                    : ""
                }}
              </li>
              <li v-if="proposal.researcherUniversityJobId == notUniversity">
                <strong class="c-purple"> نام دانشگاه: </strong>

                {{ proposal.researcherUniversityJobOther }}
              </li>

              <li>
                <strong class="c-purple">آخرین مدرک تحصیلی: </strong>

                {{ proposal.researcherLastDegree }}
              </li>
              <li>
                <strong class="c-purple"
                  >اهم فعالیت‌های تحقیقاتی پایان یافته و یا در حال اجراء و
                  تألیفات در ارتباط مستقیم با موضوع طرح:
                </strong>

                {{ proposal.researcherResearch }}
              </li>
              <li>
                <strong class="c-purple"
                  >اهم فعالیت‌های صنعتی پایان یافته و یا در حال اجرا در ارتباط
                  مستقیم با موضوع طرح:
                </strong>

                {{ proposal.researcherIndustry }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="warning">
            <h5 class="mb-0">اطلاعات همکاران طرح</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <strong class="c-purple h5"
              >تعداد همکاران طرح: {{ proposal.colleagues.length }}</strong
            >
            <hr />
            <b-card
              class="border-0 px-2"
              v-for="(colleague, index) in proposal.colleagues"
              :key="index"
            >
              <template v-slot:header>
                <strong class="c-purple">همکار شماره {{ index + 1 }}</strong>
              </template>
              <ul>
                <li>
                  <strong class="c-purple">نام:</strong>

                  {{ colleague.name }}
                </li>
                <li>
                  <strong class="c-purple">نام خانوادگی:</strong>

                  {{ colleague.lastName }}
                </li>
                <li>
                  <strong class="c-purple">کدملی:</strong>

                  {{ colleague.natCode }}
                </li>
                <li>
                  <strong class="c-purple">تلفن همراه:</strong>

                  {{ colleague.mobile }}
                </li>

                <li>
                  <strong class="c-purple">پست الکترونیکی:</strong>

                  {{ colleague.email }}
                </li>

                <li>
                  <strong class="c-purple">سمت:</strong>

                  {{ colleague.position }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل تحصیل:</strong>

                  {{
                    colleague.universityId
                      ? universities.filter(
                          (x) => x.id == colleague.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == colleague.universityId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li v-if="colleague.universityId == notUniversity">
                  <strong class="c-purple"> نام دانشگاه: </strong>

                  {{ colleague.universityOther }}
                </li>

                <li>
                  <strong class="c-purple"
                    >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:</strong
                  >

                  {{
                    colleague.universityJobId
                      ? universities.filter(
                          (x) => x.id == colleague.universityJobId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == colleague.universityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li v-if="colleague.universityJobId == notUniversity">
                  <strong class="c-purple"> نام دانشگاه: </strong>

                  {{ colleague.universityJobOther }}
                </li>
                <li>
                  <strong class="c-purple">آخرین مدرک تحصیلی:</strong>

                  {{ colleague.lastDegree }}
                </li>
                <li>
                  رزومه همکار:
                  <a
                    v-if="colleague.resumeFile"
                    :href="colleague.resumeFile"
                    target="blank"
                    >دانلود</a
                  >
                  <span v-else>--</span>
                </li>
              </ul>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <!-- NOTE (b-accordion4) previous -->
          <b-button block v-b-toggle.accordion-5 variant="info">
            <h5 class="mb-0">مشخصات طرح</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ul>
              <li class="mb-1">
                <strong class="c-purple">چکیده طرح:</strong>

                {{ proposal.abstract }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple"
                  >ضرورت اجرای طرح (در جهت دستیابی به اهداف ستاد و یا راهبردها و
                  اقدامات سند توسعه زیست فناوری):</strong
                >

                {{ proposal.requestNecessity }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple">اهداف کلان طرح:</strong>

                {{ proposal.majorGoals }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple">اهداف خرد طرح:</strong>

                {{ proposal.minorGoals }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple">مزایای دیگر برای کشور:</strong>

                {{ proposal.benefitsToCountry }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple"
                  >روش شناسی (متدولوژی) و مراحل انجام طرح:</strong
                >

                {{ proposal.methodology }}
              </li>
              <hr />
              <li v-if="proposal.requestProducts.length > 0">
                <strong class="c-purple"
                  >دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا خدمات)
                  حاصل از اجرای طرح:</strong
                >

                <!-- NOTE (t-achivments) to show the achivments and output list -->

                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    :items="proposal.requestProducts"
                    :fields="achievmentFieldsDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary my-3"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple"
                  >سابقه اجرائی یا طرح‌های مشابه در ایران یا خارج از كشور (با
                  ذكر ماخذ):</strong
                >

                {{ proposal.executionHistorySimilar }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple"
                  >شركای بین‌المللی در اجرای طرح :</strong
                >

                {{ proposal.internationalPartners }}
              </li>
              <hr />
              <li class="mb-1">
                <strong class="c-purple">منابع و ماخذ:</strong>

                {{ proposal.references }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-7 variant="warning">
            <h5 class="mb-0">زمان بندی طرح&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="mb-1">
              <strong class="c-purple">زمان شروع:</strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : ""
              }}
            </p>

            <p class="mb-1">
              <strong class="c-purple">زمان پایان:</strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : ""
              }}
            </p>
            <p>
              <strong class="c-purple">مدت زمان:</strong>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
            </p>

            <div>
              <sarmadGantt :items="proposal.gantData" :fields="serviceFields" />
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <!-- NOTE (b-accordion7) previous -->
          <b-button block v-b-toggle.accordion-8 variant="light">
            <h5 class="mb-0">هزینه‌ها&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
          <div>
            <b-card-text class="p-3">
              <div v-if="proposal.personnelCosts.length > 0">
                <h5 class="mt-5 mb-3 c-purple">
                  هزینه‌های پرسنلی اعم از مجری و همكاران
                </h5>

                <!-- NOTE (t-personnelCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    :items="proposal.personnelCosts"
                    :fields="PersonnelCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(humanResourceCost)="data">
                      <div>
                        {{
                          (
                            parseInt(data.item.perPersonCost) *
                            parseInt(data.item.cooperationHour)
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                </div>
                <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                <p>
                  جمع کل هزینه های پرسنلی:
                  {{
                    proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </p>
              </div>

              <div v-if="proposal.travelExpenses.length > 0">
                <h5 class="mt-5 mb-3 c-purple">
                  هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                  نقل، حق مأموریت و ...):
                </h5>

                <!-- NOTE (t-tripCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    :items="proposal.travelExpenses"
                    :fields="tripCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
                جمع کل مسافرتهای ضروری:
                {{
                  proposal.travelExpenses.length == 0
                    ? 0
                    : proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>
              <div v-if="proposal.purchases.length > 0">
                <h5 class="mt-5 mb-3 c-purple">
                  هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل اعتبار
                  طرح خریداری شوند:
                </h5>

                <!-- NOTE (t-deviceCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    :items="proposal.purchases"
                    :fields="deviceCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div>
                        {{
                          (
                            parseInt(data.item.number) *
                            parseInt(data.item.perPrice)
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                </div>
                جمع کل هزینه دستگاه‌ها:
                {{
                  proposal.purchases.length == 0
                    ? 0
                    : proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
                <hr />
              </div>

              <div v-if="proposal.participationOrganizationBudget.length > 0">
                <h5 class="mt-5 mb-3 c-purple">میزان مشارکت سایر موسسات:</h5>

                <!-- NOTE (t-orgCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    :items="proposal.participationOrganizationBudget"
                    :fields="OrgCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
                جمع کل مشارکت موسسات:
                {{
                  proposal.participationOrganizationBudget.length == 0
                    ? 0
                    : proposal.participationOrganizationBudget
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>
              <div
                v-show="
                  proposal.otherCosts
                    .map((x) => x.totalPrice)
                    .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                "
              >
                <h5 class="mt-5 mb-3 c-purple">هزینه‌های دیگر:</h5>

                <!-- NOTE (t-otherCost2) previous -->
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    :items="proposal.otherCosts"
                    :fields="otherCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
                <p>
                  جمع کل سایر هزینه‌ها:
                  {{
                    proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </p>
              </div>
              <h4 class="font-weight-bold">
                جمع کل هزینه‌ها:
                {{
                  (tPrice = (
                    (proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.travelExpenses.length == 0
                      ? 0
                      : proposal.travelExpenses
                          .map((x) => x.cost)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.purchases.length == 0
                      ? 0
                      : proposal.purchases
                          .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                  ).toLocaleString())
                }}
                تومان
              </h4>
              <hr />
              <h4 class="font-weight-bold">
                میزان اعتبار مورد نیاز از ستاد زیست فناوری:
                {{ computedTotalCost.toLocaleString() }}
                تومان
              </h4>
            </b-card-text>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-9 variant="dark">
            <h5 class="mb-0">اطلاعات داوران پیشنهادی&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <h5 class="c-purple">
              تعداد داوران طرح: {{ proposal.reviewers.length }}
            </h5>
            <hr />
            <b-card
              class="mt-3 border-0 px-2"
              v-for="(reviewer, index) in proposal.reviewers"
              :key="index"
            >
              <template v-slot:header>
                <strong class="purple--text">داور شماره {{ index + 1 }}</strong>
              </template>
              <ul>
                <li>
                  <strong class="c-purple">نام: </strong>
                  <span class="text-dark">{{ reviewer.name }} </span>

                  <br />
                </li>
                <li>
                  <strong class="c-purple">نام خانوادگی: </strong>
                  <span class="text-dark">{{ reviewer.lastName }} </span>
                  <br />
                </li>
                <li>
                  <strong class="c-purple">حوزه کاری: </strong>
                  <span class="text-dark">{{ reviewer.expertise }} </span>
                  <br />
                </li>
                <li>
                  <strong class="c-purple">رشته تحصیلی: </strong>
                  <span class="text-dark">{{ reviewer.field }} </span>
                  <br />
                </li>
                <li>
                  <strong class="c-purple">آخرین مدرک تحصیلی: </strong>
                  <span class="text-dark">{{ reviewer.lastDegree }} </span>
                  <br />
                </li>
                <li>
                  <strong class="c-purple">رتبه علمی: </strong>
                  <span class="text-dark">{{ reviewer.academicRank }} </span>
                  <br />
                </li>
                <li>
                  <strong class="c-purple">پست الکترونیکی:</strong>
                  <span class="text-dark">{{ reviewer.email }} </span>
                  <br />
                </li>
                <li>
                  <strong class="c-purple">شماره تماس:</strong>
                  <span class="text-dark">{{ reviewer.mobile }} </span>
                  <br />
                </li>
              </ul>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <!-- NOTE (b-accordion9) previous -->
          <b-button block v-b-toggle.accordion-10 variant="dark">
            <h5 class="mb-0">تعهدات&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-form-group disabled>
              <b-form-checkbox
                :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[0]"
              >
                این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                {{
                  proposal.gantData.length > 0
                    ? (Math.max(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      ) -
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )) /
                        3600 /
                        24 /
                        1000 +
                      " روز"
                    : ""
                }}
              </b-form-checkbox>
              <b-form-checkbox
                :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[1]"
              >
                این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                انجام:
                {{
                  (tPrice = (
                    (proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.travelExpenses.length == 0
                      ? 0
                      : proposal.travelExpenses
                          .map((x) => x.cost)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.purchases.length == 0
                      ? 0
                      : proposal.purchases
                          .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                  ).toLocaleString())
                }}
                تومان
              </b-form-checkbox>
              <b-form-checkbox
                :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[2]"
                >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                می‌باشد.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[3]"
                >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                دارد.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[4]"
                >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                است.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[5]"
              >
                بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                بهره‌بردار:
                {{
                  proposal.researcherName + " " + proposal.researcherLastName
                }}
              </b-form-checkbox>
              <b-form-checkbox
                :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[6]"
                >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                می‌شود.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[7]"
                >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت انجام
                خواهد شد.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[8]"
                >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام طرح به
                ستاد زیست فناوری ارسال و تحویل داده می‌شود.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[9]"
                >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط مجری انجام و در سایت
                بارگذاری می‌گردد.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[10]"
                >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و به
                منزله ثبت درخواست متقاضی است.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[11]"
                >کلیه موارد فوق مورد تایید اینجانب
                {{
                  proposal.researcherName + " " + proposal.researcherLastName
                }}
                به عنوان مجری طرح و همکاران می‌باشد.</b-form-checkbox
              >
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection
import { MultiSelect } from "vue-search-select";
const sarmadGantt = () => import("./../components/sarmadGantt");
import Select2 from "v-select2-component";

export default {
  props: ["proposal", "universities", "mehvars", "companies"],
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
    MultiSelect,
  },
  data() {
    return {
      moment: moment,
      review: {
        isRequestApproved: null,
      },
      tabIndex: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        // { key: "title", label: "عنوان فایل" },
        // { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      fileItems: [],
      fileFilter: "",
      fileBusy: true,
      acc: 0,
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی" },
        { key: "operation", label: "" },
      ],
      achievmentFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی" },
      ],
      serviceItems: [],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت(تومان)" },
        { key: "perPersonCost", label: " هزینه نفر ساعت" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
        { key: "operation", label: "" },
      ],
      PersonnelCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت(تومان)" },
        { key: "perPersonCost", label: " هزینه نفر ساعت" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
      ],
      OrgCostItem: [],
      rejectMessage: "",
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
        { key: "operation", label: "" },
      ],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
      ],
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      otherCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      uploadedFiles: [],
    };
  },
  computed: {
    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
